// Delivery HTML-escapes richText ("→&quot;, <→&lt;), so richText properties arrive escaped.
// Decode via a detached textarea before injecting them as HTML. The same escaping hits JSON
// stored in a property (pickers' refs, merchandisingJson), which is decoded here before parsing.
export const decodeHtml = (s) => {
    if (typeof s !== "string" || !s) return "";
    // No DOM (e.g. SSR/tests): decode the common entities by hand.
    if (typeof document === "undefined") {
        return s
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">")
            .replace(/&amp;/g, "&");
    }
    const t = document.createElement("textarea");
    t.innerHTML = s;
    return t.value;
};

// Minimal sanitizer for editor rich text (mirrors the FTL theme's sanitizeHtml): strip active
// elements and any on*/javascript: handlers before injecting the fragment. The source is
// author-only CMS richtext, but decode-then-inject would otherwise let event-handler attributes
// (e.g. <img onerror>) through — so scrub them regardless.
export const sanitizeHtml = (html) => {
    if (!html) return "";
    const tpl = document.createElement("template");
    tpl.innerHTML = html;
    tpl.content.querySelectorAll("script, style, iframe, object, embed").forEach((n) => n.remove());
    tpl.content.querySelectorAll("*").forEach((el) => {
        [...el.attributes].forEach((attr) => {
            const name = attr.name.toLowerCase();
            const val = (attr.value || "").trim().toLowerCase();
            if (name.startsWith("on") || val.startsWith("javascript:")) el.removeAttribute(attr.name);
        });
    });
    return tpl.innerHTML;
};

export const prepareRichText = (s) => sanitizeHtml(decodeHtml(s));

// Plain-text properties (title, label, badge, caption, product name ...) arrive escaped the
// same way: the delivery endpoint wraps the whole node in an HTML-escaping wrapper
// (htmlEscaped: true, the default), so an authored "Ski & Snow" reaches React as
// "Ski &amp; Snow" and would print literally. Decode before rendering as TEXT. React escapes
// on render anyway, so this cannot reintroduce markup. Non-strings pass through untouched so
// `{title && ...}` guards keep working on the decoded value.
export const decodeText = (s) => (typeof s === "string" && s ? decodeHtml(s) : s);